// Renders the REAL ZERAMI landing HTML (served inline by our proxy) in a full-viewport iframe.
// The iframe runs on our own origin under a path that contains /partner/{code}, so the real
// landing's JS resolves the referral code and its API calls hit our proxy endpoints.
export default function Embed({ path, title = "ZERAMI" }) {
  const src = `${process.env.REACT_APP_BACKEND_URL}${path}`;
  return (
    <iframe
      title={title}
      data-testid="real-landing-frame"
      src={src}
      style={{ position: "fixed", inset: 0, width: "100%", height: "100%", border: 0 }}
    />
  );
}
